$bog_music_tube_row $mol_view
	title \
	subtitle \
	status \
	cover \
	playing false
	busy false
	play? null
	get? null
	attr *
		bog_music_tube_row_busy <= busy
	sub /
		<= Play $mol_button_minor
			hint \Слушать
			click? <=> play? null
			sub /
				<= Play_icon $mol_icon_play
		<= Cover_box $mol_view
			event *
				click?event <=> play? null
			sub /
				<= Cover $mol_image
					uri <= cover
				<= Cover_placeholder $mol_icon_music
		<= Info $mol_view
			event *
				click?event <=> play? null
			sub /
				<= Title $mol_paragraph
					title <= title
				<= Subtitle $mol_paragraph
					title <= subtitle
		<= Status $mol_view
			sub / <= status
		<= Get $mol_button_minor
			hint \Скачать в Мою музыку
			click? <=> get? null
			sub /
				<= Get_icon $mol_icon_download
